import { accessOwnerDashboard } from '~/lib/utils';

export default defineNuxtRouteMiddleware((to) => {

  // IF OWNER/TEAM
  if (accessOwnerDashboard(useUser().getUser.role) && !useUser().getUser.is_staff) {
    const isReservationQrLookup = to.path.startsWith('/reservations/verify/');
    if (!to.path.includes('/dashboard') && !isReservationQrLookup) {
      return navigateTo('/dashboard');
    }
    return;
  }
});
